import{useRef as r,useEffect as t}from"react";const e=()=>{const e=r(!1);return t((()=>(e.current=!0,()=>{e.current=!1})),[]),e.current};export{e as default,e as useMounted};
//# sourceMappingURL=useMounted.js.map
